import { Controller } from "@hotwired/stimulus"

// Radio-style chip group inside the order form.
export default class extends Controller {
  static targets = ["chip"]

  select(event) {
    this.chipTargets.forEach((c) => c.classList.remove("active"))
    event.currentTarget.classList.add("active")
  }
}
